import React from 'react';
import IconButtonBase from './IconButtonBase';
import { TIconButton } from './types';

const Tertiary = ({ as = 'button', ...rest }: TIconButton) => <IconButtonBase {...rest} as={as} kind="tertiary" />;

export default Tertiary;
